// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import React from "react";
import { useApolloClient } from "@apollo/client";
import { AsyncValidationFunction, invalid, valid } from "@hex-insights/forms";
import {
	Language,
	LanguageCheckUniqueNameDocument,
	LanguageCheckUniqueNameQuery,
	LanguageCheckUniqueNameQueryVariables,
} from "../../../Utilities";
import * as LanguageFormValues from "./form-values";

/**
 * Returns an asynchronous validation function to check that the given name is unique for the
 * Language model.
 *
 * @param ignoreID The ID of the instance to ignore (generally the current instance in an update form).
 */
export function useUniqueNameValidator(
	ignoreID?: Language["id"],
): AsyncValidationFunction<LanguageFormValues.Base["name"]> {
	const client = useApolloClient();
	return React.useCallback(
		async (value: LanguageFormValues.Base["name"]) => {
			if (value === "") {
				return valid();
			}

			const { data } = await client.query<LanguageCheckUniqueNameQuery, LanguageCheckUniqueNameQueryVariables>({
				query: LanguageCheckUniqueNameDocument,
				variables: { name: value, ignoreID },
			});

			if (data.languageConnection.totalCount === 0) {
				return valid();
			}

			return invalid("This name is taken.");
		},
		[client, ignoreID],
	);
}
